// extracted by mini-css-extract-plugin
module.exports = {"Container":"styles_Container__EN5c9","Link":"styles_Link__2yLk6"};